module.exports = __webpack_public_path__ + "static/img/fullscreen-image_hero_600.82c8238.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/about-us/fullscreen-image_hero_600.png
// module id = 4czr
// module chunks = 0